import { NumberField, NumberFieldProps } from './NumberField'

type Props = NumberFieldProps

export const IntegerField = (props: Props) => {
    return <NumberField decimalScale={0} allowNegative={false} {...props} />
}

export { type Props as IntegerFieldProps }
